<template>
  <div>
    <headerBox :current="6"></headerBox>
    <bannerBox ref="bannerChild"></bannerBox>
    <div v-if="isPC" class="content_box party_pc">
      <left-tabs ref="tabsChild" :menu="menuList" @change="getMenu"></left-tabs>
      <div class="right_box">
        <gyjz v-if="current == 0" :catid="catid"></gyjz>
        <kczx v-if="current == 1" :catid="catid"></kczx>
        <alfx v-if="current == 2" :catid="catid"></alfx>
        <xxtt v-if="current == 3" :catid="catid"></xxtt>
      </div>
    </div>
    <div v-if="!isPC" class="party_sj">
      <van-tabs
        v-model="current"
        :swipe-threshold="2"
        color="#2D85E2"
        @click="getSjMenu"
      >
        <van-tab v-for="(it, i) in menuList" :key="i" :title="it.title">
          <div style="margin-top: 10px">
            <gyjz v-if="current == 0" :catid="catid"></gyjz>
            <kczx v-if="current == 1" :catid="catid"></kczx>
            <alfx v-if="current == 2" :catid="catid"></alfx>
            <xxtt v-if="current == 3" :catid="catid"></xxtt>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <footerBox></footerBox>
    <Back-top :bottom="120" :height="100">
      <div class="iconfont icon-shangjiantou"></div>
    </Back-top>
  </div>
</template>

<script>
import bannerBox from "@/components/banner.vue";
import headerBox from "@/components/header.vue";
import footerBox from "@/components/footer.vue";
import leftMenu from "@/components/left_menu.vue";
import leftTabs from "@/components/left_tabs.vue";
import gyjz from "./components/gyjz.vue";
import kczx from "./components/kczx.vue";
import alfx from "./components/alfx.vue";
import xxtt from "./components/xxtt.vue";
import { stuTokenLoginApi } from "@/api/home";

export default {
  name: "home",
  components: {
    bannerBox,
    headerBox,
    footerBox,
    leftMenu,
    leftTabs,
    gyjz,
    kczx,
    alfx,
    xxtt,
  },
  data() {
    return {
      locationList: [],
      current: 0,
      menuList: [
        {
          title: "公益讲座",
          catid: 1,
        },
        {
          title: "课程中心",
          catid: 2,
        },
        {
          title: "案例分享",
          catid: 421,
        },
        {
          title: "学习探讨",
          catid: 422,
        },
      ],
      isPC: !window.matchMedia("(max-width: 800px)").matches,
      catid: null,
    };
  },
  mounted() {
    console.log("教育培训");
    if (this.$route.query.token) {
      this.getToken();
    }
    const savedPage = sessionStorage.getItem("newsPage");
    let index = "";
    if (savedPage) {
      // 判断是否有缓存分页
      index = this.menuList.findIndex(
        (v) => v.catid == decodeURIComponent(JSON.parse(savedPage).catid),
      );
    } else {
      index = this.menuList.findIndex(
        (v) => v.title == decodeURIComponent(this.$route.query.name),
      );
    }
    this.setLocation(index);
  },
  methods: {
    getToken() {
      console.log("this.$route.query", this.$route.query);
      let token = this.$route.query.token;
      stuTokenLoginApi({ token: token }).then((res) => {
        if (res.code == 200) {
          this.$Cookies.set("cyry_token", res.result.token);
          this.$Cookies.set("cyry_user", JSON.stringify(res.result));
          console.log("res", res);
          // 移除URL中的token参数，防止刷新后重复触发登录
          const url = new URL(window.location.href);
          url.searchParams.delete("token");
          window.history.replaceState({}, "", url.toString());
          location.reload();
        }
      });
    },
    getMenu(e) {
      sessionStorage.clear("newsPage");
      this.setLocation(e);
    },
    setLocation(index) {
      let current =
        index || index == 0 ? index : this.$refs["tabsChild"].current;
      this.current = current;
      let locationList = ["教育培训", this.menuList[current].title];
      this.locationList = locationList;
      this.$refs["tabsChild"].current = current;
      this.$refs["bannerChild"].locationList = locationList;
      this.$nextTick(() => {
        this.catid = this.menuList[index].catid;
      });
    },
    getSjMenu(e) {
      this.setLocation(e);
    },
  },
};
</script>

<style lang="scss" scoped>
// 大屏幕
@media only screen and (min-width: 800px) {
  .content_box {
    margin: 80px 100px;
    min-width: 1100px;
    overflow: scroll;
    display: flex;

    .right_box {
      width: 75%;
    }
  }

  .party_pc {
    display: flex;
  }

  .party_sj {
    display: none;
  }
}

/* 手机 */
@media only screen and (max-width: 800px) {
  .party_pc {
    display: none !important;
  }

  .party_sj {
    padding: 10px;
    padding-bottom: 100px !important;
    display: flex !important;

    /deep/ .van-tab {
      padding: 0 20px;
      font-size: 17px !important;
      width: auto !important;
    }

    /deep/ .van-tabs__nav--line {
      padding-bottom: 10px;
    }
  }
}
</style>
